import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import imageCompression from 'browser-image-compression';
// material
import { Button, Grid, Container, Stack, Typography, Avatar } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Close from '@mui/icons-material/Close';
import Edit from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import { getBase64 } from '../utils/fileUpload';
import ServiceURL from '../utils/url';
// components
import Page from '../components/Page';
// ----------------------------------------------------------------------
const ImageStyle = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  justifyContent: 'center'
}));

export default function Profile() {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(false);
  const [proImg, setImg] = useState(localStorage.getItem('avatar'));
  const profileClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleListItemClick = (tag) => {
    if (tag) {
      console.log('viewed Profile Picture');
      setOpen(false);
      setView(true);
    } else {
      document.getElementById('imageselect').click();
    }
  };
  const viewHandleClose = () => {
    setView(false);
  };
  const fileCompress = async (file) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    try {
      const compressedFile = await imageCompression(file, options);
      await uploadToServer(compressedFile); // write your own logic
    } catch (error) {
      console.log(error);
    }
  };
  const uploadToServer = (file) => {
    getBase64(file).then((result) => {
      const requestOptions = {
        id: localStorage.getItem('ectroId'),
        avatar: result
      };
      console.log(requestOptions);
      const url = `${ServiceURL}profileUpdate.php`;
      axios.post(url, requestOptions).then((res) => {
        console.log(res.data);
        if (res.data[0].status === '0') {
          localStorage.setItem('avatar', result);
          setImg(result);
        }
      });
      setOpen(false);
    });
  };
  const handleChange = (e) => {
    fileCompress(e.target.files[0]);
  };
  return (
    <div>
      <Page title="Dashboard: Profile">
        <Dialog open={view}>
          <ImageStyle src={proImg} alt={localStorage.getItem('name')} />
          <Close
            style={{
              position: 'absolute',
              top: 2,
              right: 2,
              cursor: 'pointer',
              backgroundColor: '#333',
              color: '#fff',
              borderRadius: '100%'
            }}
            onClick={viewHandleClose}
          />
        </Dialog>
        <Dialog onClose={handleClose} open={open}>
          <List sx={{ pt: 0 }}>
            <ListItem button onClick={() => handleListItemClick(1)}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: '#112833', color: '#fff' }}>
                  <AccountBoxIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="View Profile Picture" />
            </ListItem>
          </List>
          <List sx={{ pt: 0 }}>
            <ListItem button onClick={() => handleListItemClick(0)}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: '#112833', color: '#fff' }}>
                  <Edit />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Edit Profie Picture" />
              <input
                id="imageselect"
                type="file"
                accept="image/*"
                multiple={false}
                onChange={handleChange}
                style={{ display: 'none' }}
              />
            </ListItem>
          </List>
        </Dialog>
        <Container>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Profile
          </Typography>
          <Grid container direction="column" sx={{ justifyContent: 'space-between' }}>
            <Grid item align="center">
              <Avatar
                src={proImg}
                alt={localStorage.getItem('name')}
                sx={{ height: 150, width: 150, boxShadow: 4, cursor: 'pointer' }}
                onClick={profileClick}
              />
              <Typography variant="h5" style={{ color: '#555', mb: 5 }}>
                {localStorage.getItem('name')}
              </Typography>
            </Grid>
            <Grid item align="center" style={{ padding: 3 }}>
              <Typography variant="h6" style={{ color: '#555', mb: 5 }}>
                {localStorage.getItem('email')}
              </Typography>
              <Typography variant="h6" style={{ color: '#555', mb: 5 }}>
                {localStorage.getItem('job')}
              </Typography>
              <Typography variant="h6" style={{ color: '#555', mb: 5 }}>
                {localStorage.getItem('descib')}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Page>
    </div>
  );
}
